<script setup>
import dayjs from 'dayjs'
import { RichTextRenderer } from '@marvr/storyblok-rich-text-vue-renderer'

const props = defineProps({ blok: Object, date: String })

useHead({
  title: `${props.blok?.page_title ? props.blok?.page_title : props.blok?.title}`,
  meta: [
    {
      name: 'description',
      content: props.blok?.description,
    },
    {
      name: 'keywords',
      content: '',
    },
    {
      property: 'og:title',
      content: props.blok?.title,
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:locale',
      content: 'en_US',
    },
    {
      property: 'og:description',
      content: props.blok?.description,
    },
    {
      property: 'og:image',
      content: props.blok?.image?.filename,
    },
    {
      property: 'og:url',
      content: `https://www.dexon-technology.com/news/${props.blok?.full_slug}`,
    },
    {
      name: 'twitter:card',
      content: props.blok?.image?.filename,
    },
    {
      name: 'twitter:title',
      content: props.blok?.title,
    },
    {
      name: 'twitter:description',
      content: props.blok?.description,
    },
    {
      name: 'twitter:image',
      content: props.blok?.image?.filename,
    },
  ],
})
</script>

<template>
  <div
    v-editable="blok"
  >
    <nuxt-img width="896" height="505" loading="lazy" sizes="md:900px, sm:600px, xs:500px" :src="`${blok.image.filename}`" :alt="blok.title" class="mb-custom-lg w-full rounded-md" />
    <h1 class="mb-custom-sm text-2xl font-bold md:text-3xl !leading-9">
      {{ blok.title }}
    </h1>
    <div class="my-3">
      <ul class="pl-0">
        <li class="mb-0">
          <div class="flex items-center gap-x-2.5">
            <nuxt-img width="50" height="50" src="https://a.storyblok.com/f/236289/128x128/68f485c8bf/master_dexon_rgb_cs6_2-05.jpg" alt="avatar" class="h-10 w-10 rounded-full" />
            <b class="text-md text-primary font-semibold">Dexon Technology</b>
          </div>
        </li>
      </ul>
    </div>
    <div class="mb-custom-xl text-sm text-gray-500 font-medium">
      <span v-if="!props.date">{{ dayjs(props.date).format('DD MMMM YYYY') }}</span>
      <span v-else>{{ dayjs(blok.date).format('DD MMMM YYYY') }}</span>
    </div>
    <div v-if="blok" class="article auto-width">
      <RichTextRenderer :document="blok.content" />
    </div>
    <div class="mt-4 w-[130px] border border-secondary-red-100 rounded-full px-4 py-3 text-center text-secondary-red-100 font-semibold leading-6 ring-secondary-red-100/25 transition-shadow duration-200 ease-in-out lg:w-[140px] md:w-[130px] disabled:cursor-not-allowed disabled:opacity-50 hover:ring-4">
      <a :href="blok.custom_link.cached_url">
        Contact Us
      </a>
    </div>
  </div>
</template>
